import Stack from '@mui/material/Stack'
import KNCallToAction from 'components/KNCallToAction/KNCallToAction'
import { useTranslation } from 'react-i18next'

export interface QuoteErrorProps {
  quoteLinkError: string
}

const QuoteError = ({ quoteLinkError }: QuoteErrorProps) => {
  const { t } = useTranslation()

  return (
    <Stack alignItems="center" justifyContent="center">
      <KNCallToAction
        image={`/img/${quoteLinkError}.svg`}
        lottie={`/img/${quoteLinkError}-lottie.json`}
        header={t(`errors.NotFound.quote-${quoteLinkError}`)}
        content={t(`errors.NotFound.quote-content-${quoteLinkError}`)}
      />
    </Stack>
  )
}

export default QuoteError

